import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_52zr2whq85: FaireBrandEntity = {
  token: "b_52zr2whq85",
  type: "brand",
  name: "Jensen Rocks",
  avatarUrl:
    "https://cdn.faire.com/fastly/7437a2451d761fd39e13ee9bc1fb4ea879ece9dda315c3a9dd1c0c497e8321fa.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/39406d7619a6fae81aa5b2d97e25966ea32b428f53a67bf6632fe6c0a677de5b.png",
  logoUrl:
    "https://cdn.faire.com/fastly/7437a2451d761fd39e13ee9bc1fb4ea879ece9dda315c3a9dd1c0c497e8321fa.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/39406d7619a6fae81aa5b2d97e25966ea32b428f53a67bf6632fe6c0a677de5b.png",
  location: "Sussex, WI, USA",
  minimumOrderDollars: 208,
  rating: 4.9,
  reviewCount: 12,
  isInsider: true,
  description:
    "Jensen Rocks started as a small family-owned business in 1994. We realized the need for retailers to have a personalized stone-buying experience, and in response, became traveling wholesalers. Moving into 2026, we are expanding our online sales presence. This offers an opportunity to restock and explore our products as we continue to stay true to our core mission: a personal gem show on wheels. Jensen Rocks still works to offer a unique and personal experience to each customer we work with. If you are interested in an in-person visit, contact us through our Instagram or Facebook to set up an appointment.\n\n",
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:06:16.230Z",
    importedBy: "entity-db-cli",
  },
};
